import Chat from './chat';
import Message from './message';

export default { Message, Chat };



// WEBPACK FOOTER //
// ./src/components/elements/chat/index.js